import { Dispatch, SetStateAction } from 'react'
import { ItemData } from '../../core/models/Template'
import { ITabListItem } from '../../organisms/TabList'

export type ExternalAdvertisementTabId = 'devices' | 'advertisementDevices' | 'contentModeration'

export const isExternalAdvertisementTabId = (tabId: string): tabId is ExternalAdvertisementTabId =>
    tabId === 'devices' || tabId === 'advertisementDevices' || tabId === 'contentModeration'

export interface IExternalAdvertisementTab extends ITabListItem {
    id: ExternalAdvertisementTabId
}

export interface IExternalAdvertisementDevice extends ItemData {
    doohDspSettings?: {
        enabled: boolean
        name: string
        imageUrl: string
        address: string
        lat: number
        lng: number
        techReqId: string
        city: {
            region: string
            name: string
            timezone: string
        }
    }
    locationPhotoUrl?: string | null
    address?: string | null
    lat?: number | null
    lng?: number | null
    city?: IDeviceCity | null
}

export interface IDeviceCity {
    name: string
    region: string
    timezone: string
}

export type ExternalAdvertisementSelectedItem = IExternalAdvertisementDevice | null

export interface IExternalAdvertisementHooksResult {
    selectedTab: ExternalAdvertisementTabId
    setSelectedTab: Dispatch<SetStateAction<ExternalAdvertisementTabId>>
    tabList: IExternalAdvertisementTab[]
    selectedInfo: ExternalAdvertisementSelectedItem
    setSelectedInfo: Dispatch<SetStateAction<ExternalAdvertisementSelectedItem>>
    selectedItems: IExternalAdvertisementDevice[]
    setSelectedItems: Dispatch<SetStateAction<IExternalAdvertisementDevice[]>>
    moderationCount: number
    setModerationCount: Dispatch<SetStateAction<number>>
}

export interface IDevicesSidebarProps {
    selected: ExternalAdvertisementSelectedItem
    selectedTab: ExternalAdvertisementTabId
    selectedItems: IExternalAdvertisementDevice[]
    onCancel: () => void
}

export interface IAdvertisementDeviceStatus {
    status: boolean
    digitalSignageId: Array<string | number>
    groupId: Array<string | number>
}

export type DeviceModalSaveData = FormData | IAdvertisementDeviceStatus

export const isAdvertisementDeviceStatus = (data: DeviceModalSaveData): data is IAdvertisementDeviceStatus =>
    !(data instanceof FormData)

export interface IDeviceModalContentProps {
    selected: IExternalAdvertisementDevice
    selectedTab: ExternalAdvertisementTabId
    selectedItems?: IExternalAdvertisementDevice[]
    onClose: () => void
    onSave: (data: DeviceModalSaveData) => void
}

export interface IDeviceAdvertisementFormState {
    name: string
    photo: File | null
    address: string
    lat: number | null
    lng: number | null
    city: IDeviceCity | null
    resolution: string
}
